import React from 'react';  
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'



function TooltipButton(props) {  

	return (  
			<OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip id="overlay-example" >{props.tooltiptext}</Tooltip>}>
			<Button {...props} >{props.content}</Button>
			</OverlayTrigger>
      );  
    
}  

export default TooltipButton  
